export default __webpack_public_path__ + "static/media/crowded-drawer.651da2d8.png";